import { useTheme } from "@mui/material";

import { TileBase, TileBaseProps } from "@/components/ui-v2";
import { ModelView } from "@/features/mesh/ModelView";

export interface MeshPreviewTileProps extends TileBaseProps {
  url: string;
  onAction?: (e: React.MouseEvent, action: MeshPreviewTileAction) => void;
}

export type MeshPreviewTileAction =
  | "SELECT"
  | "DOUBLE_CLICK"
  | "OPEN_CONTEXT_MENU";

export const MeshPreviewTile = (props: MeshPreviewTileProps) => {
  const { url, onAction, ...rest } = props;
  const theme = useTheme();

  const handleAction =
    (action: MeshPreviewTileAction) => (e: React.MouseEvent) => {
      onAction?.(e, action);
    };

  return (
    <TileBase
      sx={{ background: theme.palette.secondary[6] }}
      onClick={handleAction("SELECT")}
      onDoubleClick={handleAction("DOUBLE_CLICK")}
      onContextMenu={handleAction("OPEN_CONTEXT_MENU")}
      {...rest}
    >
      <ModelView url={url} hideControls />
    </TileBase>
  );
};
